<template>
    <el-select :class="selectBg" placeholder="請選擇縣市" v-model="inputVal" style="width: 130px" no-match-text="沒有匹配資料" autocomplete="off" name="none" :disabled="disabled">
        <el-option v-for="item in county" :key="item.name" :label="item.name" :value="item.name" type="button"> </el-option>
    </el-select>
</template>
<script>
export default {
    name: 'TwCountySelect',
    props: {
        value: {
            Type: String,
            default: null,
        },
        selectBg: {
            Type: String,
            default: '',
        },
        groupBg: {
            Type: String,
            default: '',
        },
        popularCity: {
            Type: Object,
            default: null,
        },
        disabled: Boolean,
    },
    data() {
        return {
            county: [
                {
                    name: '臺北市',
                },
                {
                    name: '基隆市',
                },
                {
                    name: '新北市',
                },
                {
                    name: '連江縣',
                },
                {
                    name: '宜蘭縣',
                },
                {
                    name: '新竹市',
                },
                {
                    name: '新竹縣',
                },
                {
                    name: '桃園市',
                },
                {
                    name: '苗栗縣',
                },
                {
                    name: '臺中市',
                },
                {
                    name: '彰化縣',
                },
                {
                    name: '南投縣',
                },
                {
                    name: '嘉義市',
                },
                {
                    name: '嘉義縣',
                },
                {
                    name: '雲林縣',
                },
                {
                    name: '臺南市',
                },
                {
                    name: '高雄市',
                },
                {
                    name: '南海島',
                },
                {
                    name: '澎湖縣',
                },
                {
                    name: '金門縣',
                },
                {
                    name: '屏東縣',
                },
                {
                    name: '臺東縣',
                },
                {
                    name: '花蓮縣',
                },
            ],
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
};
</script>
<style>
.groupBlue {
    background-color: #00355d;
    width: 170px;
}

.selectBlue .el-input .el-input__inner {
    background-color: #00355d;
    border: none;
    width: 170px;
}

.groupBlack {
    width: 170px;
}

.selectBlack .el-input .el-input__inner {
    border: none;
    width: 170px;
}

.groupWhite {
    background-color: #d9d9d9;
    width: 170px;
}

.selectWhite .el-input .el-input__inner {
    border: none;
    background-color: #d9d9d9;
    width: 170px;
}
</style>
